/**
 * Number of days before an affiliation's expiration when it should be flagged as "expiring soon".
 * Used to trigger UserAffiliation.InactivityWarning notifications.
 */
export const EXPIRING_SOON_DAYS = 14;
